import React, { useContext, useEffect, useState } from 'react'
import './postdetails.sass'
import Header from '../../components/common/Header'
import { DarkModeContext } from '../../global/Theme'
import { Comment, CommentInput, CommentIndicator, CommentReply } from '../../components/post'
import { useHistory, useLocation } from 'react-router-dom'
import { getPostById, getUserData, likePost, unlikePost, bookmarkPost, unBookmarkPost, deletePost, relatedPosts } from '../../api/feed'
import { getUserByUsername } from '../../api/auth'
import moment from 'moment'
import TipModal from '../../components/feed/TipModal'
import Notifer from '../../components/feed/Notifiers'
import {
    v4 as uuidv4
} from 'uuid';

import { useSelector } from 'react-redux'
import { EmptyScreen } from '../../components/common/EmptyScreen'
import { CommentShimmer } from '../../components/common/Shimmer'

export default function PostDetails() {
    const { isDark } = useContext(DarkModeContext);
    const history = useHistory();
    const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight);
    const [locationKeys, setLocationKeys] = useState([])
    const [postUserData, setPostUserData] = useState({});
    const [postData, setPostData] = useState({});
    const [commentList, setCommentList] = useState([])
    const [isLiked, setIsLiked] = useState(false);
    const [isBookmarked, setIsBookmarked] = useState(false);
    const [isBookmarking, setIsBookmarking] = useState(false);
    const [isLiking, setIsLiking] = useState(false);
    const [isTipModalVisible, setIsTipModalVisible] = useState(false);
    const [notifiers, setNotifiers] = useState([])
    const [deletedNotifiers, setDeletedNotifiers] = useState([])
    const [isDeletePromptVisible, setIsDeletePromptVisible] = useState(false)
    const [deleteBtnStatus, setDeleteBtnStatus] = useState('Delete')
    const [loadingComment, setLoadingComment] = useState(true)
    const [initialLoadShimmer, setinitialLoadShimmer] = useState(true);

    const [relatedPostsList, setRelatedPosts] = useState([]);
    const isCommentIndicatorVisible = useSelector(store => store.commmentIndicator);
    const userData = useSelector(state => state.userState)
    const type = window.location.href.split('/')[5];
	const location = useLocation();
    const [id, setId] = useState(location.pathname.split('/')[2])



    useEffect(() => {
        try {
            for (var i = 0; i < Object.entries(postData.whoLiked).length; i++) {
                if (Object.entries(postData.whoLiked)[i][0] == userData.id && Object.entries(postData.whoLiked)[i][1] == true) {
                    setIsLiked(true);
                    break;
                }
            }
        } catch {

        }
    }, [postData.whoLiked])

    useEffect(() => {
        try {
            for (var i = 0; i < Object.entries(postData.whoBookmarked).length; i++) {
                if (Object.entries(postData.whoBookmarked)[i][0] == userData.id && Object.entries(postData.whoBookmarked)[i][1] == true) {
                    setIsBookmarked(true);
                    break;
                }
            }
        } catch {
        }
    }, [postData.whoBookmarked])

    const handleClick = () => {
        history.goBack()
        document.getElementById('mobileWrapper').style.display = "block";
        document.getElementById('desktopWrapper').style.display = "block";
    }

    const getPostData = async () => {
        const postId = window.location.href.split('/')[4];
        getPostById(postId, async observer => {
            try {
                const res = await getUserData(observer.data().user)
                setPostUserData(res);
                setPostData(observer.data())
                const tempRelatedPosts = await relatedPosts(res.id)
                const filteredTempRelatedPosts = tempRelatedPosts.filter(post=>post.data().id  !== postId)
                setRelatedPosts(filteredTempRelatedPosts);
            } catch (e) {
                console.log(e)
            }
        });
    }


    useEffect(() => {
        getPostData();
        if(document.body.clientWidth > 750){
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
        } else if(document.body.clientWidth > 580 && document.body.clientWidth < 750){
            document.getElementById('mainWrapper').style.cssText = "padding: 0 0 0 0 !important"
        }
        return () => {
            document.getElementById('mainWrapper').style.cssText = ""
        }
    }, [])



    // fetching comments
    useEffect(() => {
        setLoadingComment(true)
        try {
            let tempCommentList = []
            Object.entries(postData.whoCommented).forEach(e => {
                tempCommentList.push(e[1])
            });
            tempCommentList.sort(function (a, b) {
                var c = (a.time.seconds);
                var d = (b.time.seconds);
                return d - c;
            });
            setTimeout(() => {
                setCommentList(tempCommentList);
                setLoadingComment(false)
                setinitialLoadShimmer(false);
            }, 200)
            
        } catch (e) { }
    }, [postData.whoCommented])

    // toogle use effect of scrollbar theme
    useEffect(() => {
        if (isDark) {
            document.getElementById('postCommnetList').classList.add('darkScrollbar');
            document.getElementById('postCommnetList').classList.remove('lightScrollbar');
        } else {
            document.getElementById('postCommnetList').classList.add('lightScrollbar');
            document.getElementById('postCommnetList').classList.remove('darkScrollbar');
        }

    }, [isDark])


    // use effect for mobile view of postdetails just like chat.js

    const updateWindowWidth = () => {
        setBodyHeight(document.body.clientHeight);
        setBodyWidth(document.body.clientWidth);
    }

    useEffect(() => {
        if (bodyWidth < 786) {
            document.getElementById('postDetailsRCol').style.display = "none";
            document.getElementById('mobileWrapper').style.display = "none";
            document.getElementById('desktopWrapper').style.display = "none";
            document.getElementById('mainWrapper').classList.add('post');
            document.getElementById('relatedPostHeader').style.display = "none"
            if(document.getElementById('relatedPostsContainer')){
                document.getElementById('relatedPostsContainer').style.display = 'none';
            }
        } else {
            document.getElementById('mainWrapper').classList.remove('post');
            document.getElementById('postDetailsRCol').style.display = "flex";
            document.getElementById('mobileWrapper').style.display = "block";
            document.getElementById('desktopWrapper').style.display = "block";
            document.getElementById('relatedPostHeader').style.display = "flex"
            if(document.getElementById('relatedPostsContainer')){
                document.getElementById('relatedPostsContainer').style.display = 'block';
            }
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
        }
    }, [])


    useEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        if (bodyWidth < 786) {
            document.getElementById('postDetailsRCol').style.display = "none";
            document.getElementById('mobileWrapper').style.display = "none";
            document.getElementById('desktopWrapper').style.display = "none";
            document.getElementById('mainWrapper').classList.add('post');
            document.getElementById('relatedPostHeader').style.display = "none"
            document.getElementById('mainWrapper').style.cssText = "padding: 0 0 0 0 !important"
            if(document.getElementById('relatedPostsContainer')){
                document.getElementById('relatedPostsContainer').style.display = 'none';
            }
        } else {
            document.getElementById('mainWrapper').classList.remove('post');
            document.getElementById('postDetailsRCol').style.display = "flex";
            document.getElementById('mobileWrapper').style.display = "block";
            document.getElementById('desktopWrapper').style.display = "block";
            document.getElementById('relatedPostHeader').style.display = "flex"
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"
            if(document.getElementById('relatedPostsContainer')){
                document.getElementById('relatedPostsContainer').style.display = 'block';
            }
        }
    }, [bodyHeight, bodyWidth, relatedPostsList])

    useEffect(() => {
        history.listen(location => {
            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    document.getElementById('desktopWrapper').style.display = "flex";
                    document.getElementById('mobileWrapper').style.display = "flex"

                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    document.getElementById('desktopWrapper').style.display = "flex";
                    document.getElementById('mobileWrapper').style.display = "flex"

                }
                history.location.state = {'postId': id, type: type}
            }
        })
    }, [locationKeys])

    const getTimeAgo = (time) => {
        try {
            return moment(new Date((time.seconds + time.nanoseconds * 10 ** -9) * 1000)).fromNow()
        } catch (e) { }
    }

    useEffect(() => {
        return () => {
            document.getElementById('mainWrapper').classList.remove('post')
        }
    }, [])

    const handleOpenPostAuthor = () => {
        history.push(`/user/${postUserData.username}`)
    }


    const handleBookmarkPost = async () => {
        setIsBookmarking(true);
        setIsBookmarked(true);
        await bookmarkPost(postData.id);
        setIsBookmarking(false);
        handleOnBookmark()
        // onBookmark()
    }

    const handleUnBookmarkPost = async () => {
        setIsBookmarking(true);
        setIsBookmarked(false);
        await unBookmarkPost(postData.id);
        setIsBookmarking(false);
    }

    const handleLikePost = async () => {
        setIsLiking(true);
        // setLikesCountState(likesCountState => likesCountState + 1)
        setIsLiked(true);
        await likePost(postData.id);
        setIsLiking(false);

    }

    const handleUnlikePost = async () => {
        setIsLiking(true);
        // setLikesCountState(likesCountState => likesCountState - 1)
        setIsLiked(false);
        await unlikePost(postData.id)
        setIsLiking(false);
    }


    const handleDeletePost = async () => {
        setDeleteBtnStatus('Deleting..')
        try {
            await deletePost(postData.id);
            history.goBack()
        } catch (e) {
            setDeleteBtnStatus('Failed')
        }



    }

    const handleDeletePostPrompt = async () => {
        if (!isDeletePromptVisible)
            setIsDeletePromptVisible(true)
        else {
            document.getElementById('deletePrompt').style.transform = 'scale(0)'
           // await sleep(1000)
            setIsDeletePromptVisible(false)

        }
    }


    const handleDeleteDialogTransition = async () => {
        if (isDeletePromptVisible) {
            document.getElementById('deletePrompt').style.transform = 'scale(1)'
            await sleep(1000)
        }
    }

    useEffect(() => {
        handleDeleteDialogTransition()
    }, [isDeletePromptVisible])

    // notifiers
    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    useEffect(() => {
        const n = notifiers.filter(notifier => !deletedNotifiers.includes(notifier.id))
        setNotifiers(n)
    }, [deletedNotifiers])

    const handleCloseNotifier = (id) => {
        setDeletedNotifiers(deletedNotifiers => [...deletedNotifiers, id])

    }

    const handleOnBookmark = async () => {
        const uid = uuidv4().toString().replaceAll('-', '')
        setNotifiers(notifiers => [...notifiers, { content: 'Added to Bookmarks!', icon: 'notifierbook.svg', id: uid }])
        try {
            await sleep(500)
            document.getElementById(uid).style.opacity = 1
        } catch (e) { }
        await sleep(2500)
        try {
            document.getElementById(uid).style.opacity = 0
            await sleep(500)
        } catch (e) { }
        setDeletedNotifiers(deletedNotifiers => [...deletedNotifiers, uid])
    }

    const handleCloseTipModal = async () => {
        if (!isTipModalVisible) {
            setIsTipModalVisible(!isTipModalVisible)
            return;
        }
        document.getElementById(postData.id).style.transform = 'scale(0)'
       // await sleep(1500)
        setIsTipModalVisible(!isTipModalVisible)
    }

    const gotoPost = (type, pID) => {
        history.push({
            pathname: (type == 1) ? `/post/${pID}/img` : `/post/${pID}/mp4`
        });
    }

    useEffect(()=>{
        getPostData();

    }, [location])

    return (
        <div id="postDetailsWrapper">
            <div id="postDetails">
                <div id="postDetailsRCol">
                    <div id="postCard" className={isDark ? 'post-details-dark' : ''}>
                        <div id="postAuthor">
                            <div id="postAuthorLeft">
                                <img onClick={handleOpenPostAuthor} src={postUserData.thumbnail} />
                                <div>
                                    <h1 onClick={handleOpenPostAuthor} className={isDark ? 'post-details-dark' : ''}>{postUserData.username} <span> {postData.body}</span></h1>
                                    <p>{getTimeAgo(postData.time)}</p>
                                </div>
                            </div>
                            <div id="postAuthorRight">
                                {isDeletePromptVisible && <div id="deletePrompt">
                                    <div id="deletePromptWrapper">
                                        <img src={require("../../assets/icons/polygon.svg")} />
                                        <div id="deleteDialog">
                                            <h1>Are you sure?</h1>
                                            <div id="deleteDialogActions">
                                                <div id="circleCross">
                                                    <img onClick={handleDeletePostPrompt} src={require("../../assets/icons/cross.svg")} />
                                                </div>
                                                <div onClick={handleDeletePost} id="postDeleteButton">
                                                    <p>{deleteBtnStatus}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                                {userData.id == postData.user && <img onClick={handleDeletePostPrompt} src={require('../../assets/icons/trash_a.svg')} />}
                            </div>
                        </div>
                        <div id="postImg">
                            <div className="notifiers">
                                {isTipModalVisible && <TipModal id={postData.id} onCloseClick={handleCloseTipModal} />}
                                {
                                    notifiers.map(notifier =>
                                        <Notifer onCloseClick={handleCloseNotifier} id={notifier.id} content={notifier.content} icon={notifier.icon} />)
                                }
                            </div>
                            {(type == 'img') ? <img src={postData.media} /> : <video src={postData.media} autoplay loop muted preload controls />}
                        </div>

                        <div id="postActions">
                            <div id="postActionsLCol">
                                <div className="feed-action">
                                    {!isLiked ? <img onClick={!isLiking ? handleLikePost : null} src={require('../../assets/icons/heart.svg')} /> : <img onClick={!isLiking ? handleUnlikePost : null} src={require('../../assets/icons/heart_a.svg')} />}
                                    <p>{postData.likesCount}</p>
                                </div>
                                <div className="feed-action">
                                    {<img src={require('../../assets/icons/comment.svg')} />}
                                    <p>{postData.whoCommented ? Object.entries(postData.whoCommented).length : 0}</p>
                                </div>
                                <div onClick={handleCloseTipModal} className="feed-action">
                                    <img src={require('../../assets/icons/tip.svg')} />
                                    <p>SEND TIP</p>
                                </div>
                            </div>
                            <div id="postActionsRCol">
                                <div className="feed-action">
                                    {!isBookmarked ? <img onClick={!isBookmarking ? handleBookmarkPost : null} src={require('../../assets/icons/bookmark.svg')} /> : <img onClick={!isBookmarking ? handleUnBookmarkPost : null} src={require('../../assets/icons/bookmark_a.svg')} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="postDetailsLCol">
                    <Header handleClick={handleClick} img="backbutton.svg" text="Comments" />
                    <div id="postCommnetList" className={!isCommentIndicatorVisible ? 'max-height-comment' : 'height-comment'}>
                        {
                             
                            loadingComment && initialLoadShimmer ?

                            <div>
                            
                            </div>
                            :
                            commentList && commentList.length > 0 ?
                            commentList.map(comment => comment.parent == postData.id ?
                            <Comment parentId={postData.id} key={comment.uid} whoLiked={comment.whoLiked} likesCount={comment.likesCount} commentList={commentList} uid={comment.uid} text={comment.comment} mention={comment.mention} mentionID={comment.mentionID} author={comment.user} time={comment.time} /> : null
                            ):
                            <EmptyScreen logo='comment_a' heading='No comments' description='There are no new comments left on your activity.' />
                        }
                    </div>
                    <CommentIndicator />
                    <CommentInput postID={postData.id} placeholder="Write a comment..." />
                </div>
            </div>

            <div id="relatedPostHeader" className={isDark ? 'lover-header-dark' : 'lover-header-light'}>
                <h1>More posts from @{postUserData.username}</h1>

            </div>
            {relatedPostsList.length > 0 && <div id="relatedPostsContainer">
                <div id="relatedPostsWrapper">
                    {relatedPostsList.map(post => post.data().type == 1 ? <img id={post.id} onClick={()=>gotoPost(post.data().type, post.data().id)} className='related-post-item' src={post.data().media} /> : <video onClick={()=>gotoPost(post.data().type, post.data().id)} controls id={post.id} className='related-post-item' src={post.data().media} />)}
                </div>
            </div>}
        </div>
    )
}

// loadingComment && initialLoadShimmer ?